<template>
  <layout :showuserinfo="false" >
    <div class="container-fluid">
            <div class="page-wrapper-portal">
                <MenuNav />  
                <div class="card card-pkn">
                   
                    <!-- <Menu :auth="auth" :link="'carian'" />     -->

                    <div class="card-body card-scroll">

                        <!-- -->
                        <div class="row">
                           
                            <template v-if="butirans.length > 0"> 
                            <div class="col-lg-9">
                                <div class="row justify-content-center">
                                    <div class="">
                                        <div class="card report-card">
                                            <div class="card-body">
                                            

                                        <div class="col-lg-12">
                                            <div class="card" >
                                            <div class="card-header">
                                                <h4 class="card-title"><b class="text-primary">1.</b> Senarai Pembayaran</h4>
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                                <div class="table-responsive shopping-cart">
                                                    <table class="table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th class="border-top-0" rowspan="2">Jenis Pembayaran</th>   
                                                                <th rowspan="2">No. Rujukan | Nama</th>
                                                                <th rowspan="2">Jabatan</th>           
                                                                <th class="border-top-0 text-center" colspan="2">Amaun  (RM)</th>
                                                                <th rowspan="2"></th>
                                                            </tr>
                                                            <tr>
                                                                <th class="border-top-0 text-center">Perlu Bayar</th>
                                                                <th class="border-top-0 text-center"> Bayar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="dt, index in butirans">
                                                               <template v-if="dt.bakul == 1">
                                                                <tr>
                                                                <td>
                                                                    {{dt.sumber_keterangan}} 
                                                                </td>
                                                                <td @click="paparan(dt)" style="cursor: pointer;">
                                                                {{dt.no_rujukan}} | {{dt.keterangan}}</td>
                                                                <td>{{dt.jabatan}}</td>
                                                                <td class="text-right" >{{$zutil.currency(dt.amaun)}}  </td>
                                                                <td>
                                                                    <template v-if="dt.sumber.am == 1">
                                                                        <z-money :validators="[validators.required]" v-model:originalValue="dt.amaun_bayar" v-on:keyup="checkAmaun(dt)" v-on:change="pilih(dt, 1)"  readonly/>
                                                                         <span class="tw-form-el__error error">{{dt.mesej}}</span>
                                                                        
                                                                    </template>
                                                                    <template v-else>
                                                                        <z-money :validators="[validators.required]" v-model:originalValue="dt.amaun_bayar" v-on:keyup="checkAmaun(dt)" v-on:change="pilih(dt, 1)"  />
                                                                         <span class="tw-form-el__error error">{{dt.mesej}}</span>
                                                                        
                                                                    </template>
                                                                    
                                                                    
                                                                </td>
                                                                <td>
                                                                    <template v-if="dt.sumber.am == 1"> 
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class="btn-pkn-2" @click="pilih(dt, 0)">
                                                                            Padam <i class="dripicons-trash" ></i>
                                                                        </div>
                                                                    </template>
                                                                </td>
                                                                </tr>
                                                                </template>                                                        
                                                            
                                                        </template>
                                                            
                                                            <tr>
                                                                
                                                                <td>
                                                                    <h6>Jumlah :</h6>
                                                                </td>
                                                                <td></td>
                                                                <td></td>
                                                                <td class="text-dark text-right"><strong>{{$zutil.currency(total_pilih)}}   </strong></td>
                                                                <!-- <td></td> -->
                                                            </tr>                                                    
                                                        </tbody>
                                                    </table>

                                                    <!-- <code>* <b>Nota</b> : Sila Pastikan Setiap Pembayaran adalah tepat dan betul, sebelom melakukan pembayaran. Terima Kasih</code> -->

                                                </div><!--end re-table-->

                                            </div><!--end card-body-->
                                            </div>
                                        </div><!--end col--> 


                                        
                                        <div class="col-lg-12" v-if="auth.user.id == 0">

                                            <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="simpanProfil()" >
                                            <div class="card" v-if="total_pilih">
                                            <div class="card-header">
                                                <h4 class="card-title"><b class="text-primary">2.</b> Profil Pembayar</h4>
                                                <!-- <p class="text-muted mb-0">Sila Pastikan maklumat dibawah adalah benar dan tepat.</p> -->
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                            <w-flex class="mt2">
                                                <div class="xs6 mr5">
                                                    <w-input  v-model="form.nama" required label="Nama *"  :validators="[validators.required]" /> 
                                                </div>
                                                <div class="xs6">
                                                    <w-input  v-model="form.no_id" required label="No. KP / Pasport / Syarikat *"  :validators="[validators.required]" />  
                                                </div>
                                            </w-flex>
                                            <w-flex class="mt2">
                                                <div class="xs6 mr5">
                                                    <w-input  v-model="form.emel" required label="Emel *"  :validators="[validators.required, validators.email]" /> 
                                                </div>
                                                <div class="xs6">
                                                    <w-input  v-model="form.no_tel" required label="No Tel *"  :validators="[validators.required]" />  
                                                </div>
                                            </w-flex>
                                            <w-flex class="mt2">
                                                <div class="xs12 mr5">
                                                    <w-textarea v-model="form.alamat1" :validators="[validators.required]">Alamat *</w-textarea>
                                                </div>
                                            </w-flex>

                                            <!-- <w-button class="my1" @click="caraBayar()" > Teruskan</w-button> -->
                                            <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent"> Teruskan</w-button>
                                            <center><template v-if="callback">
                                                    <a :href="callback" class="mr3 mt4 btn btn-warning">Kembali</a>
                                                </template></center>
                                                
                                                
                                            </div><!--end card-body-->
                                            </div>
                                        </w-form>
                                        </div><!--end col--> 
                                         
                                        
                                            <!-- -->



                                        </div><!--end card-body--> 

                                    </div><!--end card--> 
                                </div> <!--end col--> 

                                    <!-- -->

                                </div><!--end row-->

                            </div><!--end col-->
                            <div class="col-lg-3">
                                <div class="card" >
                                    <div class="card-header">
                                        <div class="row align-items-center">
                                            <div class="col">                      
                                                <h4 class="card-title"><i class="mdi mdi-cart-outline me-2"></i> Senarai Jenis Pembayaran  Ingin Dibayar</h4>                      
                                            </div><!--end col-->
                                        </div>  <!--end row-->                                  
                                    </div><!--end card-header-->
                                    <div class="card-body">
                                        <div class="text-center">
                                            <div id="ana_device" class="apex-charts hide"></div>
                                            
                                        </div>  
                                        <div class="table-responsive mt-2" v-if="total_pilih">
                                            <table class="table border-dashed mb-0">
                                                <thead>
                                                <tr>
                                                    <th>Jenis Pembayaran</th>
                                                    <th class="text-end">Jumlah (RM)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <!-- <tr v-if="total_cukai_pilih">
                                                    <td>CUKAI</td>
                                                    <td class="text-end"> {{$zutil.currency(total_cukai_pilih)}}</td>
                                                </tr>
                                                <tr v-if="total_perumahan_pilih">
                                                    <td>PERUMAHAN</td>
                                                    <td class="text-end"> {{$zutil.currency(total_perumahan_pilih)}}</td>
                                                </tr>

                                                <tr v-if="total_pendidikan_pilih">
                                                    <td>PENDIDIKAN</td>
                                                    <td class="text-end"> {{$zutil.currency(total_pendidikan_pilih)}}</td>
                                                </tr> -->
                                                
                                                </tbody><thead>
                                                <tr>
                                                    <th>Jumlah</th>
                                                    <th class="text-end"> {{$zutil.currency(total_pilih)}}</th>
                                                    
                                                </tr>
                                                </thead>                                           
                                                
                                            </table><!--end /table-->
                                        </div><!--end /div-->                                 
                                    </div><!--end card-body--> 
                                </div><!--end card--> 

                                
                                <div class="card" v-if="total_pilih && cara_bayar">
                                    <div class="card-header">
                                        <h4 class="card-title"> <b class="text-primary"  @click="pilihCaraTerima(1)">
                                            <template v-if="auth.user.id == 0">3.</template>
                                            <template v-else>3.</template>
                                        </b> Cara Pembayaran</h4>
                                    </div><!--end card-header-->
                                    <div class="card-body">
                                        <div class="d-flex">
                                            <div class="d-block ms-2 align-self-center">
                                                
                                                
                                            </div>
                                        </div>
                                        <div class="accordion accordion-flush checkout-accordion" id="accordionFlushExample">

                                            <!-- <div class="accordion-item" v-if=" total_pilih >= 1">
                                              <h2 class="accordion-header mt-0" id="flush-headingTwo" @click="pilihCaraTerima(1)">
                                                <button class="accordion-button collapsed d-flex " type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"  @click="pilihCaraTerima(1)">                                                
                                                    <img src="assets/images/cards/card-10.svg" alt="" height="30 " >
                                                    <span class="align-self-center ms-2 fw-semibold">FPX</span> &nbsp;&nbsp;&nbsp;<h2><i class="dripicons-checkmark"  v-if="form.lkp_cara_terima_id == 1"></i></h2>
                                                </button>
                                              </h2>
                                              
                                            </div> -->
                                            <div class="accordion-item">
                                              <h2 class="accordion-header mt-0" id="flush-headingOne">
                                                <button class="accordion-button collapsed d-flex " type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo" @click="pilihCaraTerima(2)">                                               
                                                    <img src="assets/images/cards/card-2.png" alt="" height="30">
                                                    <span class="align-self-center ms-2 fw-semibold">Kad Kredit</span>  &nbsp;&nbsp;&nbsp;<h2><i class="dripicons-checkmark"  v-if="form.lkp_cara_terima_id == 2"></i></h2>
                                                </button>
                                              </h2>
                                              
                                            </div>
                                            
                                        </div>                   
                                    </div><!--end card-body-->
                                </div>
                                
                                <!-- <div class="card " v-if="total_pilih && cara_bayar">
                                    <div class="card-body">
                                        <h7>Had limit kadar bayaran FPX :<br>

                                        - Maksimum B2B RM1,000,000<br>
                                        - Minimum B2B RM2.00<br>

                                        - Maksimum B2C RM30,000<br>
                                        - Minimum B2C RM1.00</h7>  
                                    </div>       
                                </div>     -->
                                <div class="card" v-if="total_pilih && cara_bayar">
                                    
                                
                                    <div class="card-header">
                                        <h4 class="card-title"> Terma & Syarat</h4>
                                    </div><!--end card-header-->
                                    <div class="card-body">
                                        Disini saya mengesahkan bahawa saya memperakui segala terma dan syarat yang telah ditetapkan oleh pihak kerajaan kedah melalui platform iBayaq
                                        <br>
                                        <w-checkbox v-model="form.agree">Setuju terima dan syarat</w-checkbox> <br>
                                        <template v-if="form.agree == true && form.lkp_cara_terima_id != 0 && form.check_amaun != 0">
                                            <!-- <form action="http://pg.lokal.my/pay/proceed" method="post"> -->
                                            <form :action="url_payment" method="post">
                                            <input type="hidden" name="flow" value="01">
                                            <input type="hidden" name="api" value="1">
                                            <input type="hidden" name="token" value="1234">
                                            <input type="hidden" name="method" v-model="form.lkp_cara_terima_id">
                                            <input type="hidden" name="id" v-model="troli.id">
<!--                                             <input type="hidden" name="payment_id" v-model="troli.payment_id">
                                            <input type="hidden" name="order_id" v-model="troli.order_id"> -->
                                            <input type="hidden" name="return_url" v-model="url_return">
                                            <input type="hidden" name="callback_url" v-model="url_callback">
                                            <input type="hidden" name="amount" v-model="total_pilih">
                                            <input type="hidden" name="name" v-model="data_profil.nama">
                                            <input type="hidden" name="email" v-model="data_profil.emel">
                                            <input type="hidden" name="profil_id" v-model="data_profil.id">
                                            <input type="hidden" name="mobile" v-model="data_profil.no_tel">
                                            <input type="hidden" name="description" value="Bayaran iBayaq">
                                            <!-- <button type="submit">Bayar</button> -->
                                            <w-button class="my1" type="submit" :disabled="form.valid === false" >Bayar </w-button>
                                            </form>
                                        </template>
                                        <template v-else>
                                            <w-button class="my1" :disabled="true" > Bayar</w-button>
                                        </template>
                                        
                                    </div><!--end card-body-->

                                </div>
                                
                                        

                            </div> <!--end col--> 

               </template>
                        </div><!--end row-->
                        <!-- -->

                    </div><!--end card-body--> 
                </div>
                

            </div>


        </div>
    
<w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-pencil</w-icon>
       {{dialog.data.sumber_keterangan}}
    </template>
    <div class="page-wrapper-portal">
        <div class="row card-scroll">

            <template v-if="dialog.data.lkp_sumber_id" >
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">No Rujukan :</div>
                          <div class="fw-normal ">{{dialog.data.detail.no_rujukan}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jabatan</div>
                          <div class="fw-normal ">{{dialog.data.jabatan}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>

                    <div class="xs6">
                          <div class="fw-semibold m0">No KP :</div>
                          <div class="fw-normal ">{{dialog.data.detail.no_kp}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama  :</div>
                          <div class="fw-normal ">{{dialog.data.detail.nama}}</div>
                    </div>
                    
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">NO TELEFON :</div>
                          <div class="fw-normal ">{{dialog.data.detail.no_tel}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">EMEL :</div>
                          <div class="fw-normal ">{{dialog.data.detail.emel}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jumlah Perlu Bayar (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.amaun}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">
                              <template v-if="dialog.data.lkp_sumber_id == 7">Perihal</template>
                          </div>
                          <div class="fw-normal "><template v-if="dialog.data.lkp_sumber_id == 7">{{dialog.data.detail.perihal}}</template></div>
                    </div>
                </w-flex>
                
            </template>
        </div>
    </div>

      <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      </template>
</w-dialog>
  </layout>
</template>

<script type="text/javascript">
    import Menu from '../Menu.vue'
    import MenuNav from '../MenuNav.vue'

import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
    components: {
      Menu,MenuNav
    },
    setup () {

    },
    props: {
        auth: [Array, Object],
        butirans : [Array, Object],
        profil : Object,
        troli : Object,
        url_callback : String,
        url_return : String,
        url_payment : String,
        callback: [Array, Object],
        form : [Array, Object],
    },
    data() {
        return {
            no_rujukan: '',
            lkp_sumber_id : '',
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: ' ',
                precision: 2,
                masked: false
            },
            description_pay : '',
            data_profil : {},
            cara_bayar : 0,
            senarai : [],
            total_carian : 0,
            total_pilih : 0,
            total_cukai_pilih : 0,
            total_perumahan_pilih :0,
            total_pendidikan_pilih : 0,
            cari : 0,
            form : {
                lkp_cara_terima_id : 0,
                check_amaun : 1
            },
            dialog: {
              valid: false,
              show: false,
              fullscreen: false,
              persistent: true,
              persistentNoAnimation: false,
              loading: false,
              width: 800,
              data: {}
            },
        }
    },
    methods: {
      carian () {

        this.$inertia.visit(window.route('landing.cart')+'?no_rujukan='+this.no_rujukan+'&lkp_sumber_id='+this.lkp_sumber_id, {preserveState:true, onSuccess: () => {return Promise.all([this.total(),])}})
      },

      paparan(dt){
        this.dialog.show = 1
        this.dialog.data = dt
      },

      send(){
        // alert('oke');
        var form = document.getElementById("send");
        form.action = 'http://pg.lokal.my/pay/proceed';
        return true;
      },

      total(){
        this.form.nama = this.profil.nama
        this.form.no_id = this.profil.no_id
        this.form.no_tel = this.profil.no_tel
        this.form.emel = this.profil.emel
        this.form.alamat1 = this.profil.alamat1
         this.total_carian = 0
         this.total_pilih = 0
         this.total_cukai_pilih = 0
         this.total_perumahan_pilih  = 0
         this.total_pendidikan_pilih = 0
         this.form.check_amaun = 1
         this.description_pay = ""
        for (var i in this.butirans) {
            if(this.butirans[i].bakul == 1){
                this.total_pilih = this.total_pilih + this.butirans[i].amaun_bayar
                if(this.butirans[i].lkp_sumber_id == 1){
                    this.total_cukai_pilih = this.total_cukai_pilih + this.butirans[i].amaun_bayar
                }
                if(this.butirans[i].lkp_sumber_id == 2){
                    this.total_perumahan_pilih = this.total_perumahan_pilih + this.butirans[i].amaun_bayar
                }

                if(this.butirans[i].lkp_sumber_id == 3){
                    this.total_pendidikan_pilih = this.total_pendidikan_pilih + this.butirans[i].amaun_bayar
                }
                this.description_pay = this.description_pay+' '+this.butirans[i].sumber_keterangan+' '+this.butirans[i].no_rujukan+''
            }else{
                this.total_carian = this.total_carian + this.butirans[i].amaun_bayar
            }
            if(this.butirans[i].amaun_bayar < this.butirans[i].amaun_min){
                this.form.check_amaun = 0

            }
        }
        this.no_rujukan = ''

        if(this.auth.user.id > 0){
            this.caraBayar();
        }
      },

      caraBayar(){
        this.cara_bayar = 1;
      },

      bayar(){
        this.$zcomm.add('butiran.bayar', this.form)
        .then(res => {
          
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$zutil.notify ("Data Berjaya Dihantar.")
          // if(this.auth.user.id != 0){
              this.$inertia.visit(this.$route('landing.transaksi')+'?resit_id='+res)
          // }else{
          //   this.$inertia.visit(this.$route('landing'))
          // }
          
        })
        .finally(() => {
            
        });
      },
      simpanProfil(){

        this.$zcomm.add('profil.simpan', this.form)
        .then(res => {
          
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$zutil.notify ("Data Berjaya Simpan.")
          this.data_profil = res
          this.caraBayar()
          // if(this.auth.user.id != 0){
              // this.$inertia.visit(this.$route('landing.transaksi')+'?resit_id='+res)
          // }else{
          //   this.$inertia.visit(this.$route('landing'))
          // }
          
        })
        .finally(() => {
            
        });

      },

      checkAmaun(dt){

        if(dt.amaun_bayar < dt.amaun_min){
            dt.mesej = 'Amaun Minimun ' + this.$zutil.currency(dt.amaun_min)
        }else{
            dt.mesej = null
        }
        this.total()
      },

      pilih(dt, bakul){
        dt.bakul = bakul
        if(bakul == 0){
            dt.amaun_bayar = dt.amaun
        }
        if(confirm("Anda Pasti?")){
        this.$zcomm.store('butiran.bakul', dt)
        .then(res => {
          
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          if(bakul == 1){
              this.$zutil.notify ("Data Berjaya Ditambahkan.")
          }else{
            this.$zutil.notify ("Data Berjaya Dipadamkan.")
          }
          
        })
        .finally(() => {
            
        });
        }
        this.total()
      },

      pilihCaraTerima(id){
        this.form.lkp_cara_terima_id = id
      }

    },
  mounted() {
    // override default setting
    
    this.total()
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.no_rujukan){
        this.no_rujukan = this.cari.no_rujukan
        this.lkp_sumber_id = this.cari.lkp_sumber_id
        this.carian();
    }
    if(this.profil){
        this.data_profil = this.profil
    }
  }
}
</script>

<style type="text/css">
.pkn-carian-landing 
{
    position: inherit !important;
}
</style>